import { requestBuilder } from '../../http/RequestBuilder';

export interface ICTTradingDayResponse {
    tradingDay: string;
}

const useGetICTTradingDay = requestBuilder.query<ICTTradingDayResponse>({
    endpoint: '/api/ict/trading-day',
    queryKey: '/ict/trading-day',
});

export default useGetICTTradingDay;
